import { mapGetters, mapState } from 'vuex';
import emailValidator from 'email-validator';

import store from '../store';

export const checkoutMixin = {
  data() {
    return {
      name: '',
      email: '',
      error: null,
      errorModalOpen: false,
    };
  },

  computed: {
    ...mapState('cart', ['subscribeToMailingList']),
    ...mapGetters('cart', ['total']),

    canSubmit() {
      return (
        this.name !== '' &&
        this.email !== '' &&
        emailValidator.validate(this.email)
      );
    },
  },

  methods: {
    async handlePayWithStripe() {
      const { payment_id } = await this.handlePay('stripe');
      const stripe = Stripe(process.env.MIX_STRIPE_PUBLIC_KEY);
      await stripe.redirectToCheckout({
        sessionId: payment_id,
      });
    },

    handlePayWithPayop() {
      this.handlePay('payop')
        .then(res => {
          window.location = `https://payop.com/en/payment/invoice-preprocessing/${
            res.payment_id
          }`;
        })
        .catch(error => {
          console.error('Payment error with Payop', error);
        });
    },

    async handlePayWithPaymentwall() {
      const {
        payment_id,
      } = await this.handlePay('paymentwall');

      fetch('/api/checkout/execute', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          provider: 'paymentwall',
          transaction_id: payment_id,
          payment_token: null,
        }),
      })
        .then(res => res.json())
        .then(res => {
          if (!res.redirect_url) {
            this.handlePaymentError(res);
            throw new Error('The payment execution failed.');
          }
          window.location = res.redirect_url
        })
        .catch(error => {
          throw error;
        });
    },

    handlePayWithSkrill() {
      this.handlePay('skrill')
        .then(res => {
          window.location = `https://pay.skrill.com/app/?sid=${res.payment_id}`;
        })
        .catch(error => {
          console.error('Payment error with Skrill', error);
        });
    },

    async handlePayWithPaysafe() {
      const {
        payment_id,
        amount,
      } = await this.handlePay('paysafe');

      const options = {
        amount,
        currency: 'USD',
        environment: process.env.NODE_ENV === 'production' ? 'LIVE' : 'TEST',
        companyName: process.env.MIX_PAYSAFE_COMPANY_NAME,
        accounts: {
          CC: +process.env.MIX_PAYSAFE_ACCOUNT_NUMBER,
        },
        // threeDS: {
        //   useThreeDSecureVersion2: true,
        // },
      };
      paysafe.checkout.setup(
        btoa(process.env.MIX_PAYSAFE_PUBLIC_TOKEN),
        options,
        (...args) => this.handleExecuteWithPaysafe(payment_id, ...args)
      );
    },

    handlePay(provider) {
      const { cart } = store.state;
      const items = cart.items.map(({ extra }) => extra);
      const coupon = cart.coupon;

      return fetch('/api/checkout/setup', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          provider,
          name: this.name,
          email: this.email,
          items,
          coupon,
          subscribe_to_mailing_list: cart.subscribeToMailingList,
        }),
      })
        .then(res => res.json())
        .then(res => {
          if (!res.payment_id) {
            this.handlePaymentError(res);
            throw new Error('The API did not return a Payment ID.');
          }
          return res;
        });
    },

    handleExecuteWithPaysafe(transaction_id, instance, error, result) {
      if (error) {
        instance.close()
        this.handlePaymentError(error);
        throw new Error("Something went wrong when trying to setup your payment.");
      }

      const { token, paymentMethod } = result
      if (!(token && paymentMethod === 'Cards')) {
        instance.close()
        throw new Error("Something went wrong when trying to setup your payment.");
      }

      return fetch('/api/checkout/execute', {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          provider: 'paysafe',
          transaction_id,
          payment_token: token,
        }),
      })
        .then(res => res.json())
        .then(res => {
          if (!res.redirect_url) {
            this.handlePaymentError(res);
            throw new Error('The payment execution failed.');
          }
          window.location = res.redirect_url
        })
        .catch(error => {
          instance.close()
          throw error;
        });
    },

    handlePaymentError(error) {
      this.setError(error);
    },

    setError(error) {
      this.error = error;
      this.errorModalOpen = true;
    },

    closeModal() {
      this.error = null;
      this.errorModalOpen = false;
    },

    updateMailingListSubscription(event) {
      this.$store.commit(
        'cart/setMailingListSubscription',
        event.target.checked
      );
    },
  },
};
